module.exports = __webpack_public_path__ + "static/img/code1.ba5b4b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/code1.jpg
// module id = 1qan
// module chunks = 19